import Store from '../Redux/Store/Store';
import { SetErrorStatus } from '../Redux/Slices/CommonLocalRedux/CommonSliceStorage';
import {
    SetTopMenuNavigation,
    setLeftHeadMenu,
    SetLeftMenuTap,
    setPageName,
    SetLandingPage,
    Set_TOP_NAVIGATION,
    Set_LEFT_MENU_NAVIGATION,
    Set_SUB_LEFT_MENU_NAVIGATION
} from '../Redux/Slices/CommonLocalRedux/NavigationSlice';

const getSelectedCoCode = () => {
    const selected = Store.getState()?.LocalValuesData?.SelectedCompany;
    const company = Array.isArray(selected) ? selected[0] : selected;
    return company?.Co_Code || company?.co_code || company?.CO_CODE || '';
};

export const goToCompanyModule = (dispatch, navigate) => {
    const coCode = getSelectedCoCode();

    if (!coCode) {
        dispatch(SetErrorStatus(false));
        dispatch(SetTopMenuNavigation([2, 'Home']));
        dispatch(SetLandingPage(true));
        dispatch(setLeftHeadMenu(''));
        dispatch(SetLeftMenuTap(''));
        dispatch(setPageName(''));
        dispatch(Set_TOP_NAVIGATION(''));
        dispatch(Set_LEFT_MENU_NAVIGATION(''));
        dispatch(Set_SUB_LEFT_MENU_NAVIGATION(''));
        navigate('/Landing');
        return;
    }

    dispatch(SetErrorStatus(false));
    dispatch(SetTopMenuNavigation([2, 'Company']));
    dispatch(SetLandingPage(false));
    dispatch(setLeftHeadMenu('General'));
    dispatch(SetLeftMenuTap('Background'));
    dispatch(setPageName('Background'));
    dispatch(Set_TOP_NAVIGATION('Company'));
    dispatch(Set_LEFT_MENU_NAVIGATION('General'));
    dispatch(Set_SUB_LEFT_MENU_NAVIGATION('Background'));
    navigate('/Company/General/Background');
};

export const goToTpScreenerModule = (dispatch, navigate) => {
    dispatch(SetTopMenuNavigation([98, 'TP Screener']));
    const lastTpModule = sessionStorage.getItem('tp_main_module') || 'filter';
    navigate(`/tp-screener/${lastTpModule}`);
};

export const goToEMagazineModule = (dispatch, navigate) => {
    dispatch(SetTopMenuNavigation([99, 'e-Magazine']));
    navigate('/e-magazine');
};
